import { h } from 'preact';
import { isLocalMoviePage } from 'utils/data';
import { isBaseRegion, isFocusStudio } from 'utils/studioConfig';

import UniversalMovieMediaEditor from 'components/editor/movies/movieMedia/movieMediaUniversal';
import UniversalBaseMovieMediaEditor from 'components/editor/movies/movieMedia/movieMediaUniversalBase';
import UniversalLocalMovieMediaEditor from 'components/editor/movies/movieMedia/movieMediaUniversalLocal';
import FocusMovieMediaEditor from 'components/editor/movies/movieMedia/movieMediaFocus';

export default (props) => {
	if (isFocusStudio()) return <FocusMovieMediaEditor {...props} />;
	if (isBaseRegion()) return <UniversalBaseMovieMediaEditor {...props} />;
	if (isLocalMoviePage(props.data)) return <UniversalLocalMovieMediaEditor {...props} />;
	return <UniversalMovieMediaEditor {...props} />;
};
